export default function IMEIBasedSuccessRateTableHeaderDayView() {

  function createDaysOfWeekThTags(weeks = {}) {
    const dayOfWeekThTags = [];
    const weeksASC = Object.keys(weeks).sort((a, b) => a.localeCompare(b));

    weeksASC.forEach((w) => {
      const daysASC = Object.keys(weeks[w]).sort((a, b) => a.localeCompare(b));
      dayOfWeekThTags.push(
        ...[...daysASC, "Total"].map((d) => m("th[colspan=4]", d))
      );
    });

    return m("tr.text-center.align-middle", dayOfWeekThTags);
  }

  return {
    view: (vnode) => {
      return createDaysOfWeekThTags(vnode.attrs.weeks)
    }
  }
}